import { render } from "./ReviewSummary.vue?vue&type=template&id=704e8ce6&ts=true"
import script from "./ReviewSummary.vue?vue&type=script&lang=ts"
export * from "./ReviewSummary.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__